import { baseVariables } from '@marriott/mi-ui-library';
import { envVarKeys } from './envVarKeys';

export const constants = {
  RTL_LANG_LIST: `:lang(he-IL), :lang(ar-AE)`,
  NOTO_SANS_LANG_LIST: `:lang(ko-KR), :lang(ja-JP), :lang(zh-CN), :lang(zh-TW) `,
  ARABIC_LANG: `:lang(ar-AE)`,
  HEBREW_LANG: `:lang(he-IL)`,
  HINDI_LANG: `:lang(hi-IN)`,
  JAPAN_COUNTRY_CODE: 'JP',
  KOREA_COUNTRY_CODE: 'KR',
  CANADA_COUNTRY_CODE: 'CA',
  ARABIC_COUNTRY_CODE: 'AE',
  CHINA_COUNTRY_CODE: 'CN',
  USA_COUNTRY_CODE: 'US',
  MEXICO_COUNTRY_CODE: 'MX',
  ARGENTINA_COUNTRY_CODE: 'AR',
  TRADITIONAL_CHINA_COUNTRY_CODE: 'TW',
  CHINA_HK_LOCALE_CODE: 'HK',
  CHINA_MO_LOCALE_CODE: 'MO',
  DEFAULT_LANG: 'en',
  BRITISH_LANG: 'gb',
  DEFAULT_COUNTRY: 'US',
  THAI_LANG: 'th',
  ITEM_PATH_ROOT: 'root/responsivegrid',
  BORDER10: 'rgba(0,0,0,0.1)',
  TRANSPARENT: 'transparent',
  STANDARD_DATE_FORMAT: 'YYYY-MM-DD',
  TAB_UPCOMING: 'tabUpcoming',
  TAB_CANCELLED: 'tabCancelled',
  TAB_BUSINESS: 'tabBusiness',
  TAB_LEISURE: 'tabLeisure',
  CONTACT_OPT_PH: 'PH',
  CONTACT_OPT_BOTH: 'BOTH',
  MAX_BRAND_TAGS: 3,
  BOLD_FONT_WEIGHT: 800,
  SESSION_TIME_OUT_URL: '/sessionTimeOut',
  RES_LOOKUP_ID: 'reservationlookup',
  UNAUTH_URL: '/unAuth',
  ENROLL_PREFILL: '/enrollprefill',
  PROMOTION_PREPROCESSOR_URL: '/promotion',
  NO_DECIMAL_LOCALE: ['ko_KR'],
  KOREAN_CURRENCY: 'KRW',
  //Activity Codes
  STAY: 'STAY',
  RWD_EVENT: 'RWD EVENT',
  BONUS: 'BONUS',
  OTHER: 'OTHER',
  SUITE_NIGHT: 'suite-night',
  MILES_CURRENCY_CODE: 'MI',
  POINTS_CURRENCY_CODE: 'HP',
  //Activity Codes END
  MR_ENROLLED: 'mr_enrolled',
  LOYALTY_PAGE_PATH: '/loyalty',
  FIND_RESERVATION_LIST_PAGE_URL: '/loyalty/findReservationList.mi',
  CREATE_ACCOUNT_PAGE_URL: '/loyalty/createAccount/createAccountPage1.mi',
  STATUS_SUCCESS: 'SUCCESS',
  INVALID_PARTNER_NUMBER: 'INVALID_PARTNER_NUMBER',
  UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
  DC_ERROR_FLAG: 'profile.registered.to.dc.program',
  STATUS_FAILURE: 'FAILURE',
  HOME_PHONE_CODE: 'HT',
  BUSINESS_PHONE_CODE: 'BT',
  MOBILE_PHOHE_CODE: 'MT',
  USA_COUNTRY_DIAL_CODE: '+1',
  RESERVATION_LINKED: 'reservationLinkedMsg',
  USA_COUNTRY: 'USA',
  ALLOWED_YEAR_THRESHOLD: 100,
  CONVERSION_POINTS_SYMBOL: '=',
  RAKUTEN_PARTNER: 'RK',
  MGM_PARTNER: 'MM',
  PARTNER_CURRENCY: 'POINTS',
  AWARDS: 'awards',
  MILES: 'MILES',
  ALL_LOCALES_CODE: 'all',
  NEXT_PUBLIC_ENV_KEYS: [
    'PROHIBITED_COUNTRIES_CODES',
    'CREDIT_CARD_EXPIRY_YEAR_LIMIT',
    'SWEEPSTAKES_RESTRICTED_PROVINCES',
    'SWEEPSTAKES_OTP_PAGE_URL',
    'SWEEPSTAKES_FINAL_API_URL',
    'COBRAND_LOCALE',
    'HOMEPAGE_REDIRECT_URL',
    'IS_PASSWORD_ENCRYPT',
    'SKIP_DECODE_URL_FOR_PATH',
    'FETCH_MEMBER_DETAILS_FOR_PATHS',
    'PROMOS_WITHOUT_DEFAULT_EARNED_TEXT',
    'NEXT_PUBLIC_GRAPHQL_URL',
    'NEXT_PUBLIC_PREFIX',
    'NEXT_PUBLIC_DEFAULT_LANG',
    'ADD_CARD_MARSHA_CODE',
    'NEXT_PUBLIC_SUBMIT_SEARCH_URL',
    'LOCALIZED_NAME_LOCALES',
    'PATTERN_THREE_COUNTRIES',
    'HIDE_PAID_MEDIA_MARKETING_CONSENT_FOR_COUNTRIES',
    'URLS_TO_CLEAR_SESSION_DATA',
    'OTA_CREATOR_IDS',
    'NEXT_PUBLIC_DAC_LOGO_ENABLE',
    'TRIP_UXL_NON_CRITICAL_NODES',
    'APOLLOGRAPHQL_PUBLIC_REQUIRE_SAFELISTING',
    'FEATURE_FLAG_API_KEY_CLIENT',
    ...Object.keys(envVarKeys),
  ],
  CHECK_IN_CONFIRMATION: '/reservation/check-in-confirmation.mi',
  FIND_RESERVATION_DETAIL: '/reservation/upcomingReservation.mi',
  LOGOUT_URL: 'logout',
  SYSTEM_MAINTENANCE: 'systemMaintenance',
  GERMAN_LOCALE: 'de-de',
  US_LOCALE: 'en-us',
  DEFAULT: 'DEFAULT',
  FONTICON: 'fonticon',
  TEXT: 'text',
  HIDE_ROW_HEADER: 'HIDE-ROW-HEADER',
  ICON: 'ICON',
  CONTENTBLOCKV2: 'CONTENT_BLOCK_V2',
  LOCALE_KEY_CHINA: 'zh-CN',
  OTP_LOCKOUT_ERROR_MESSAGE: 'otpLockedOutErrorMessage',
  EAA_ERROR_URL: '/error',
  EAA_LOGIN_URL: '/login',
  MCOM_LOGIN_URL: '/sign-in.mi',
  SONDER_BRAND_CODE: 'SN',
  EMAIL: 'email',
  PHONE: 'phone',
  OTP_EMAIL: 'OTP_EMAIL',
  OTP_PHONE: 'OOB_SMS',
  MEMBER_LEVEL_CODE: ['R', 'MRD', 'MGD'],
  VERTICAL_PIPE: '|',
  TITANIUM_LEVEL_CODE: 'PPC',
  VARIATION_2: 'V2',
  VARIATION_3: 'V3',
  CORE_LEVEL_CODE: ['R', 'S', 'G'],
  SILVER_MEMBER_NIGHTS: 10,
  PARTNER_CARD_HEADER_LIMIT: 46,
  PARTNER_CARD_SUB_HEADER_LIMIT: 88,
  SUCCESS_CODE: '200',
  CANCEL_REMOVE_CARD: 'remove-card',
  CANCEL_REPORT_CARD: 'report-card',
  EXPIRING_SOON_DAYS: 90,
  EXPERIENCE_SEGMENT: ['NOT Logged In'],
  CANCELLED_CARD: 'CANCELLED',
  PARTNER_RELATIONSHIP_FILTERS: ['FRANCHISE_OWNER', 'RITZ_CARLTON_CLUB', 'MVW_OWNER'],
  RESIDENCE_OWNER: 'RESIDENCE_OWNER',
  RITZ_CARLTON_CLUB: 'RITZ_CARLTON_CLUB',
  ASSOCIATE_GROUP_CODES: ['A', 'Q', 'G', 'B'],
  HOTEL_OWNER_GROUP_CODES: ['O'],
  AWARD_TYPES: ['free-night-awards', 'suite-night-awards'],
  EN_US: 'en-us',
  NON_EN_US: 'non-en-us',
};

export const FLYOUT_CONFIG_VALUES = {
  SKIP_DECODE_URL_FOR_PATH: 'einterface,/search/findHotels',
  HOMEPAGE_REDIRECT_URL: '/default.mi',
};

//colors
export const memberStatusCardBorder = 'rgba(255, 255, 255, 0.5)';

// TODO: Please clean up and migraes to constants (above)
export const accountConstants = {
  DEFAULT_LANG: 'en_US',
  DEFAULT_COUNTRY: 'US',
  DOWNSIZE_PARAM: '?output-quality=70&interpolation=progressive-bilinear&downsize=',
  VIEWPORT_SIZE: {
    desktop: '1200px',
    largerTablet: '1024px',
    mediumTablet: '992px',
    tablet: '768px',
    mobile: '576px',
  },
  CONTENT_BLOCK_IMAGE_WIDTH: {
    lg: 433,
    md: 345,
    sm: 315,
  },
  BREAKPOINT_TABLET: 768,
  BREAKPOINT_DESKTOP: 992,
  ITEM_PATH_ROOT: 'root/responsivegrid',
};

export const JOIN_CONFIRMATION_PROMOTION_BASE_URL = '/loyalty/join/joinConfirmationPromotion.mi';

export const JOIN_PROMOTION_BASE_URL = '/loyalty/join/joinPromotion.mi';

export const PROMOTIONS_CONSTANT = {
  REGISTERED_PROMOTIONS_STATE_CODES: ['RMA', 'RSP', 'RE', 'RNP', 'IP'],
  NEW_PROMOTIONS_STATE_CODES: ['U'],
  PROMOTIONS_MAX_ACHIEVED_STATE_CODES: ['RMA', 'PEMA'],
  PROMO_HURDLE_TYPE_STAYS_CODE: 'stays',
  PROMO_HURDLE_TYPE_NIGHTS_CODE: 'nights',
  POINTS_EARNING_PREF: 'HP',
  FREE_NIGHTS_EARNING_PREF: 'FN',
  ELITE_NIGHTS_EARNING_PREF: 'NT',
  PLATINUM_UPGRADE: 'UP',
  PROMOTION_MAX_GOAL_KEY: 'max',
  PROMOTION_DETAIL_KEYS: ['short', 'details', 'additional', 'tc'],
  PROMOTIONS_URL: '/loyalty/promotion.mi?promotion={promotionCode}',
  PROMOTIONS_CENTRAL_URL: '/loyalty/myAccount/promotionCentral.mi',
  PROMOTION_UNAVAILABLE_URL: '/loyalty/promotionUnavailable.mi',

  JOIN_PROMOTION_URL: `${JOIN_PROMOTION_BASE_URL}?promotion={0}`,
  JOIN_CONFIRMATION_PROMOTION_URL: `${JOIN_CONFIRMATION_PROMOTION_BASE_URL}?promotion={0}`,
  //List of offers Id's that are not available to existing members
  UNAVAILABLE_PROMOTIONAL_OFFERS_LIST_CONFIG_KEY: ['MT'],
  //List of offers Id's that are available to existing members
  AVAILABLE_PROMOTIONAL_OFFERS_LIST_CONFIG_KEY: ['MT004'],
  PROMOTION_IMG_OUTPUT_INTERPOLATION: 'progressive-bilinear',
  HTML_TAG_REGEX: /<\/?[^>]+(>|$)/g, // regex to find html tags
  BANNER_TITLE_CHARACTER_LIMIT: 127,
};

export const OVERVIEW_CONSTANT = {
  ANNUAL_CONSTANTS: ['PFS', 'PFR', 'PPC', 'PL7'],
  AMBASSADOR_CODE: ['PFS', 'PFR', 'PPAE'],
  PLATINUM_CODE: ['PAC', 'PAR', 'PLR'],
  TITANIUM_CODE: ['PL7', 'PPR', 'PPC'],
  TITANIUM_REFERRAL_CODE: 'PPR',
  REFERRAL_CODE: ['GAR', 'SAR', 'PAR', 'PFR', 'PPR'],
  MEMBER_CODE: ['MRD', 'MGD'],
  SILVER_LABEL: 'Silver',
  GOLD_LABEL: 'Gold',
  PLATINUM_LABEL: 'Platinum',
  FILLED_COLOR_NON_MEMBER: baseVariables.color['base20'],
  FILLED_COLOR_MEMBER: baseVariables.color['accent10'],
  TEXT_COLOR_MEMBER: baseVariables.color['base10'],
  MEMBER_BONUS_PROMOTION_LABEL: 'Promotion',
  MEMBER_BONUS_VISA_LABEL: 'Visa',
  MEMBER_BONUS_RWD_LABEL: 'Rwd Event',
  HIDE_LIFETIME_SECTION_CODES: ['PL7', 'PFS', 'PFR', 'PLR', 'PPAE'],
  MEMBER_LEVELS: ['Silver', 'Gold', 'Platinum'],
  SILVER_LIFETIME: 'SLR',
  GOLD_LIFETIME: 'GLR',
  PLATINUM_LIFETIME: 'PLR',
  TITANIUM_LIFETIME: 'PL7',
  UNFILLED_COLOR_MEMBER_NO_NIGHT: baseVariables.color['neutral20'],
  NIGHT_PROGRESS_DATA: {
    innerRadius: 0.8,
    outerRadius: 0.78,
    padAngle: 0.01,
    cornerRadius: 2,
    circle: {
      radius: 0.03,
      stroke: 0.03,
    },
  },

  SAVED_HOTEL_CONSTANTS: {
    croppingRatio: 6,
    outputQuality: 90,
    outputInterpolation: 'progressive-bilinear',
    imageDimensions: {
      height: 221,
      width: 332,
    },
  },

  MEMBER_LEVEL_MSG_ICONS: {
    renew: 'icon-renew',
    successfully_renewed: 'icon-promotion-achieved',
    level_up: 'icon-next-level-genera',
    nights_awards_level: 'icon-next-level-{nightAward}-day',
    titanium_only: 'icon-ambassador',
    ambassador_only: 'icon-ambassador',
  },

  LIFEITME_ACHIEVER: 'LifetimeAchiever',
  LIFEITME_RENEWED: 'LifetimeRenewed',
  AMBASSADOR_REFERRAL: 'AmbassadorReferral',
  AMBASSADOR_ACHIEVER: 'AmbassadorAchiever',
  AMBASSADOR_RENEWED: 'AmbassadorRenewed',
  TITANIUM_REFERRAL: 'TitaniumReferral',
  TITANIUM_ACHIEVER: 'TitaniumAchiever',
  TITANIUM_RENEWED: 'TitaniumRenewed',
  REFERRAL_ACCOUNT: 'ReferralAccount',
  ACHIEVER_ACCOUNT: 'AchieverAccount',
  RENEWED_ACCOUNT: 'RenewedAccount',
  BASIC_MEMBERSHIP: 'BasicMembership',
};

export const TRACKING_CONSTANTS = {
  SIGNIN: 'Sign In',
  REMEMBER_ME: 'Remember Me',
  JOIN_NOW: 'Join Now',
  FORGOT_PASSWORD: 'Forgot Password',
  ACTIVATE_ONLINE_ACCOUNT: 'Activate Online Account',
  CLEAR_REMEMBER_ME: 'Clear Remember Me',
  EYE_TOGGLE: 'Eye Toggle',
  INTERNAL: 'internal',
  OVERVIEW: 'Overview',
  MY_TRIPS: 'My Trips',
  CHECK_IN_ON_APP: 'Check in on App',
  DOWNLOAD_THE_APP: 'Download the App',
  JOIN_FOR_FREE: 'Join for Free',
  JOIN_AND_CONTINUE: 'Join and Continue',
  EMAIL_PHONE: 'Email or Phone Radio Buttons',
  SEND_CODE: 'Send Code',
  VERIFY_CODE: 'Verify',
  RESEND_CODE: 'Resend a New Code',
  CANCEL: 'Cancel',
  ENTER_YOUR_CODE: 'Enter Your Code',
  PROMOTION_ENROLLMENT: 'Promotion Enrollment',
  SWEEPSTAKES: 'Sweepstakes',
  SWEEPSTAKES_SIGNIN: 'Sweepstakes Sign In',
  EXTERNAL: 'external',
  SELECT_ANOTHER_RATE: 'Select Another Rate',
  SIGN_IN_SUBMIT: 'SignInSubmit',
  FORGOT_PASSWORD_SUBMIT: 'ForgotPasswordSubmit',
  ACTIVATE_ACCOUNT_SUBMIT: 'ActivateAccountSubmit',
  FORGOT_PASSWORD_ATTEMPT: 'ForgotPasswordAttempt',
  ACTIVATE_ACCOUNT_ATTEMPT: 'ActivateAccountAttempt',
  LOOKUP_MEMBER_SUBMIT: 'LookupMemberSubmit',
  SET_PASSWORD_SUBMIT: 'SetPasswordSubmit',
  CONFIRM_IDENTITY_SUBMIT: 'GenerateOtpSubmit',
  VERIFICATION_CODE_SUBMIT: 'ConfirmOtpSubmit',
  FORCE_CHANGE_PASSWORD_SUBMIT: 'ForceChangePasswordSubmit',
  CHANGE_PASSWORD_SUBMIT: 'ChangePasswordSubmit',
  JOIN_NOW_SUBMIT: 'JoinNowSubmit',
  SELECT_ANOTHER_RATE_CTA: 'SelectAnotherRate',
  CLEAR_REMEMBER_ME_CTA: 'ClearRememberMe',
  SEND_CODE_SUBMIT: 'SendCodeSubmit',
  ACTIVATE_ACCOUNT_LHS_SUBMIT: 'ActivateAccountLHSSubmit',
  ACTIVATE_ACCOUNT_RHS_SUBMIT: 'ActivateAccountRHSSubmit',
  SIGN_IN_TRACK: 'SignIn',
};

// pattern experiences
export const ENROLL_PATTERN_EXPERIENCES = {
  PATTERN_TWO: 2,
  PATTERN_FOUR: 4,
  PATTERN_THREE: 3,
};

// adding default locale
export enum AllLocalesKeysListConstant {
  en = 'en-US',
  cn = 'zh_CN',
  ja = 'ja_JP',
  ko = 'ko_KR',
}

export enum UserType {
  WITHIN_TWELVE_MONTHS = 'N',
  WITHIN_TWENTY_FOUR_MONTHS = 'O',
}

export enum ValueOrder {
  ENTHU = 1,
  CASUAL = 2,
  NOINTR = 3,
}

export const FOOD_LOV_BEVTYPE = 'food-lov';
export const ALERTS_BEVTYPE = 'alerts';
export const BEVERAGE_NON_ALCOHOLIC_LOV_BEVTYPE = 'beverage-non-alcoholic-lov';
export const BEVERAGE_ALCOHOLIC_LOV_BEVTYPE = 'beverage-alcoholic-lov';
export const SPA_LOV_TYPE = 'spa-lov';
export const GOLF_LOV_TYPE = 'golf-lov';
export const INTERESTS_AND_HOBBIES_LOV_TYPE = 'interests-and-hobbies-lov';
export const FITNESS_LOV_TYPE = 'fitness-lov';
export const ACCESSIBILITY = 'AC';
export const ROOM_OPTIONS = 'RO';
export const FEATHER_FREE_ID = 'B5';
export const EXTRA_FEATHER_PILLOWS_ID = 'V9';
export const ROOM_AMENITIES = 'RA';
export const FoodBevIconsType: { [key: string]: string } = {
  [FOOD_LOV_BEVTYPE]: 'icon-dining-chopsticks',
  [ALERTS_BEVTYPE]: 'icon-requests',
  [BEVERAGE_NON_ALCOHOLIC_LOV_BEVTYPE]: 'icon-grab-n-go',
  [BEVERAGE_ALCOHOLIC_LOV_BEVTYPE]: 'icon-mini-bar',
  [SPA_LOV_TYPE]: 'icon-spa',
  [INTERESTS_AND_HOBBIES_LOV_TYPE]: 'icon-activity',
  [FITNESS_LOV_TYPE]: 'icon-fitness-center',
  [ACCESSIBILITY]: 'icon-accessibility',
  [ROOM_OPTIONS]: 'icon-all-suites',
  [ROOM_AMENITIES]: 'icon-room-ready-alerts',
};

export enum CustomerTripOrderStatus {
  active = 'ACTIVE',
  checkIn = 'checkInEligible',
  modifyCheckIn = 'checkInModifiable',
  inProgressCheckout = 'checkoutEligible',
  isPhysicalCheckedIn = 'PhysicalCheckedIn',
  checkInEligibleV2 = 'CHECK_IN_ELIGIBLE',
  modifiableChekinV2 = 'CHECK_IN_MODIFIABLE',
}

//membership codes
export const MEMBERSHIP_CODES = {
  MEMBER_CODES: ['R', 'MRD', 'MGD'],
  SLIVER_MEMBER_CODES: ['S', 'SAR', 'SAC', 'SLR'],
  GOLD_MEMBER_CODES: ['G', 'GAC', 'GAR', 'GLR'],
  PLATINUM_MEMBER_CODES: ['P', 'PAR', 'PAC', 'PAR', 'PLR'],
  TITANIUM_MEMBER_CODES: ['PPE', 'PPR', 'PPC', 'PL7'],
  AMBASSADOR_MEMBER_CODES: ['PFS', 'PFR', 'PPAE'],
};

// Member status constants for dynamic benefits logic
export const MEMBER_STATUS = {
  NOT_NEAR: 'not-near',
  NEAR_RENEWING: 'near-renewing',
  NEAR_ACHIEVING: 'near-achieving',
} as const;

// Benefit description templates for mini banner
export const BENEFIT_TEMPLATES = {
  NOT_NEAR: 'notNearDescription',
  NEAR_RENEWING: 'nearRenewingDescription',
  NEAR_ACHIEVING: 'nearAchievingDescription',
} as const;

// Location restriction codes for benefit filtering
export const LOCATION_RESTRICTIONS = {
  US_CA_SLASH: `${constants.USA_COUNTRY_CODE}/${constants.CANADA_COUNTRY_CODE}`, // Backend format with slash: 'US/CA'
  US_CA_UNDERSCORE: `${constants.USA_COUNTRY_CODE}_${constants.CANADA_COUNTRY_CODE}`, // Alternative format: 'US_CA'
  US: constants.USA_COUNTRY_CODE, // 'US'
  CA: constants.CANADA_COUNTRY_CODE, // 'CA'
  NULL: 'null', // String 'null' indicates no restriction
} as const;

export type BenefitTemplateKey = (typeof BENEFIT_TEMPLATES)[keyof typeof BENEFIT_TEMPLATES];
// Night ranges for member status determination
export const MEMBER_NIGHT_RANGES = {
  // Near Achieving ranges (to next tier)
  BASIC_NEAR_ACHIEVING: { min: 7, max: 9 }, // Basic to Silver
  SILVER_NEAR_ACHIEVING: { min: 18, max: 24 }, // Silver to Gold
  GOLD_NEAR_ACHIEVING: { min: 40, max: 49 }, // Gold to Platinum
  PLATINUM_NEAR_ACHIEVING: { min: 65, max: 74 }, // Platinum to Titanium
  TITANIUM_NEAR_ACHIEVING: { min: 95, max: 99 }, // Titanium to Ambassador

  // Near Renewing ranges (current tier)
  SILVER_NEAR_RENEWING: { min: 7, max: 9 }, // Silver renewing
  GOLD_NEAR_RENEWING: { min: 18, max: 24 }, // Gold renewing
  PLATINUM_NEAR_RENEWING: { min: 40, max: 49 }, // Platinum renewing
  TITANIUM_NEAR_RENEWING: { min: 65, max: 74 }, // Titanium renewing

  // Not Near ranges (current tier)
  SILVER_NOT_NEAR: { min: 0, max: 6 }, // Silver not near (0-6)
  SILVER_NOT_NEAR_2: { min: 10, max: 17 }, // Silver not near (10-17)
  GOLD_NOT_NEAR: { min: 0, max: 17 }, // Gold not near (0-17)
  PLATINUM_NOT_NEAR: { min: 0, max: 39 }, // Platinum not near (0-39)
  TITANIUM_NOT_NEAR: { min: 0, max: 64 }, // Titanium not near (0-64)
} as const;

export const CHECKOUT_PROCESSING_WINDOW_IN_DAYS = 5;

export type MemberStatus = (typeof MEMBER_STATUS)[keyof typeof MEMBER_STATUS];

export const MEMBERSHIP_LIFETIME_CODES_MAPPING = {
  [OVERVIEW_CONSTANT.SILVER_LIFETIME]: 'S',
  [OVERVIEW_CONSTANT.GOLD_LIFETIME]: 'G',
  [OVERVIEW_CONSTANT.PLATINUM_LIFETIME]: 'P',
  [OVERVIEW_CONSTANT.TITANIUM_LIFETIME]: 'PPE',
};

export const MEMBERSHIP_CODES_MAPPING = new Map<string[], string>([
  [MEMBERSHIP_CODES.MEMBER_CODES, 'R'],
  [MEMBERSHIP_CODES.SLIVER_MEMBER_CODES, 'S'],
  [MEMBERSHIP_CODES.GOLD_MEMBER_CODES, 'G'],
  [MEMBERSHIP_CODES.PLATINUM_MEMBER_CODES, 'P'],
  [MEMBERSHIP_CODES.TITANIUM_MEMBER_CODES, 'PPC'],
  [MEMBERSHIP_CODES.AMBASSADOR_MEMBER_CODES, 'PFS'],
]);

export const CORE_LEVEL_CODES = ['R', 'S', 'G', 'P', 'PPC', 'PFS'];
export const MEMBER_LEVEL_CODE = 'R';

// Benefits display constants
export const BENEFITS_DISPLAY = {
  MAX_BENEFITS_MAIN_DISPLAY: 4, // Maximum benefits to show in main component
  MEMBER_LEVEL_LOCKED_BENEFITS_START_INDEX: 4, // Index from which Member level benefits are locked (benefits 5 & 6: 10% Bonus Points, Priority Late Checkout)
} as const;

// Mini Banner benefit rotation constants
export const BENEFIT_ROTATION = {
  SESSION_STORAGE_PREFIX: 'benefit_rotation_',
  SESSION_ID_KEY: 'benefit_session_id',
  LOGOUT_FLAG_KEY: 'benefit_logout_flag', // Flag to trigger rotation on next login
  MAX_BENEFITS_PER_TIER: 6, // Maximum benefits per tier for rotation
  // Note: Benefits rotate on every page reload for better user experience
  // This ensures users see different benefits each time they visit the page
} as const;

// brands that need to redirected to the landing page instead of the reviews page
export const HWSLandingPageRedirectionBrands = ['RZ', 'MV', 'DS', 'BG'];

// link to redirect from reviews section if going to HWS Landing Page
export const viewHotelWebsiteLink = '/hotels/travel/';

// part of link to enable redirection to HWS reviews section
export const hotelsSublink = '/hotels/';

// part of link to enable redirection to HWS reviews section
export const reviewsSubLink = '/reviews/';

// to pass as an argument to redirection hook
export const reviewsRedirectionVarValue = 'reviews';

export const borderColor = '#979797';

// copied from util constants

export const favouriteCount = 20;
export const overviewFavoritesDesktopCount = 3;

export const fallbackImages = {
  Classic: 'https://cache.marriott.com/is/image/marriotts7prod/bonvoy-error-image-10518:Classic-Hor',
  altText: 'Fallback',
};

export const fallbackImagesCN = {
  Classic: 'https://cache.marriott.com.cn/is/image/marriotts7prod/bonvoy-error-image-10518:Classic-Hor',
  altText: 'Fallback',
};

export const AMBASSADOR_PERSONAL_INFO_CATEGORY = {
  SELF_CATEGORY: 'self',
  SPOUSE_CATEGORY: 'spouse',
  CHILDREN_CATEGORY: 'children',
  PET_CATEGORY: 'pets',
};
export const NONE = 'NONE';
export const PERSONAL_INFO_PETSTYPE_DEFAULT = 'OTHER';

export const DATE_FORMATE = {
  ENGLISH_DATE_FORMAT: 'MMM DD, YYYY',
  ENGLISH_DATE_FORMAT_NUMBER: 'MM DD, YYYY',
  GERMAN_DATE_FORMAT: 'DD.MM.YYYY',
  ENGLISH_FULLMONTH_FORMAT: 'MMMM Do[st,] YYYY',
};
export const bookNowUrl = '/reservation/availability.mi?propertyCode=';
export const ALLOWED_DAY_THRESHOLD = 365;
export const ALLOWED_DAY_THRESHOLD_FIND_RESERVATION = 1;
export const CONFIRMATION_NUMBER_MAXLENGTH = 11;
export const FIRST_AND_LAST_NAME_MAXLENGTH = 30;
export const calendarConstants = {
  SHORT_WEEK_DAYS: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  SHORT_WEEK_DAYS_NAME: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  LONG_WEEK_DAYS_NAME: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  SHORT_MONTH_NAME: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
};
export const ValidMarshCodes = ['BCNRZ', 'DALIL', 'LISRZ', 'RTZ'];
export const ValidBrandIds = ['RZ'];
export const NIGHTS_LABEL = 'nights';
export const NIGHT_LABEL = 'night';

export const hotelReservationUrl = '/reservation/availability.mi?isSearch=true&propertyCode=';
export const ritzCarltonUrl = 'http://www.ritzcarlton.com/?marshaCode={marshaCode}&locale={locale}/';
export const hwshoteLReservation = '/{currentLocale}/hotels/{propertyId}-{propertyUrlName}/overview';
export const ritzCarltonBrandId = 'rz';
export const countryUSCode = 'us';
export const pageSizeLimit = 10;
export const pageSetLimit = '10';
export const defaultValuesetDurationFilter = '3';
export const defaultValuesetActivityFilter = 'all';
export const defaultPageLimitActivity = '10';

export const findReservationDetailUrl = '/reservation/upcomingReservation.mi';
export const CONFIRM_CANCELLATION_URL = '/reservation/confirmReservationCancellation.mi';
export const HYPHEN_SYMBOL = '-';
export const UNDERSCORE_SYMBOL = '_';
export const COLON_SYMBOL = ':';
export const SEMI_COLON_SYMBOL = ';';

export const DATA_LAYER_PROPERTIES = {
  NEXT_PUBLIC_ORIENTATION_LANDSCAPE: 'Landscape',
  NEXT_PUBLIC_ORIENTATION_PORTRAIT: 'Portrait',
  NEXT_PUBLIC_PAGE_BREAKPT: 'Page Loaded on ',
};

export const viewOrModifyBookingUrl =
  '/reservation/upcomingReservation.mi?confirmationNumber={confirmationNumber}&tripId={confirmationNumber}&propertyId={propertyId}';
export const checkinPropertyUrl =
  '/reservation/check-in-details.mi?confirmationNumber={confirmationNumber}&tripId={confirmationNumber}&propertyId={propertyId}';
export const cancelReservationUrl =
  '/reservation/confirmReservationCancellation.mi?confirmationNumbers={confirmationNumber}';
export const reviewCancelReservationUrl = '/reservation/reviewCancellation.mi?confirmationNumbers={confirmationNumber}';
export const tripCancellationUrl = '/mi/phoenix-account-navigation/v1/confirmCancelReservation';
export const tripCancellationUrlDtt = '/mi/phoenix-account-navigation/v2/confirmCancelReservation';

export const forgotPwrdSubmitURL = '/mi/phoenix-account-auth/v1/forgotPasswordSubmit';
export const nextDocumentUploadURL = '/mi/phoenix-account-navigation/v1/uploadDocument';
export const userPrefilledDataURL = '/mi/phoenix-account-navigation/v1/userPrefilledData';
export const enrollPrefillIdUrl = '/mi/phoenix-account-navigation/v2/enrollPrefilledData';
export const nextMissingStayFormSubmitURL = '/mi/phoenix-account-navigation/v1/submitMissingStayForm';
export const combineAccountFormSubmitURL = '/mi/phoenix-account-navigation/v1/accountMergeRequest';
export const oneClickJoinRandDecryptURL = '/mi/phoenix-account-navigation/v1/decryptEnrollmentData';
export const oneClickJoinRandDecryptURLDtt = '/mi/phoenix-account-navigation/v2/decryptEnrollmentData';
export const nextMissingStayFormConfirmationURL = '/loyalty/myAccount/missingStayRequestconfirmation.mi';
export const activateAccountUrl = '/mi/phoenix-account-navigation/v1/createOnlineAccount';
export const submitCreateOnlineAccount = '/mi/phoenix-account-navigation/v1/submitCreateOnlineAccount';
export const profileRememberMeURL = '/mi/phoenix-account-auth/v1/updateRememberMe';
export const sendOtpUrl = '/mi/phoenix-account-auth/v1/generateOneTimePassword';
export const otpVerificationUrl = '/mi/phoenix-account-auth/v1/validateOneTimePassword';
export const mfaAfterSignInUrl = '/mi/phoenix-account-auth/v1/otpCommunicationOptions';
export const emailPwrdUrl = '/emailPassword.mi';
export const encryptUserIDUrl = '/mi/phoenix-account-auth/v1/encryptConsumerId';

export const generateOneTimePwrdUrl = '/mi/phoenix-account-auth/v1/generateOTP';
export const validateOneTimePwrdForMobileUrl = '/mi/phoenix-account-auth/v1/validateOneTimePasswordForMobile';
export const validateFrequentFlyerProgram = '/mi/phoenix-account-auth/v1/validateAirlineAccountNumber';
export const forgotPwrdPageUrl = '/forgotPassword.mi';
export const verifyPointsUrl = '/mi/phoenix-account-auth/v1/transferPointsToPartners';
export const verifyMemberToMemberUrl = '/mi/phoenix-account-auth/v1/transferPointsToMember';
export const fetchModelJsonApi = '/mi/account/api/get-model';
export const EMAIL_DATA_KEY = 'customer_email';
export const MASKED_PHONE = 'masked_phone';
export const REMEMBER_ME_KEY = 'remember_me';
export const ENCRYPTED_DATA = 'encrypted_data';
export const ENCRYPTED_GIFT_CARD_DATA = 'encryptedGiftCardData';
export const ENCRYPTED_VERIFY_DATA = 'encrypted_verify_data';
export const TRACKING_PAGE_NAME = 'tracking_page_name';

export const BRANDING_QUERY_KEY = 'branding';
export const LOCALE_QUERY_KEY = 'locale';

export const MFA_OPTIONS_KEY = 'mfa_option';
export const savedHotelsImagesOrder = ['hotelView', 'guestRooms', 'suites', 'dining'];
export const savedHotelsMaxCount = 5;
export const imageDomain = 'https://cache.marriott.com';
export const imageDomainRegex = /^https:\/\/cache\.marriott\.com(?=\/|$)/;
export const imageDomainCN = 'https://cache.marriott.com.cn';
export const AmbassadorMemberCode = 'PFS';
export const CarousalArrowButtonColor = '#ffffff60'; //TODO for carousal button for savedHotel
export const CLICK_TRACK_TURN_ON =
  'Security Preferences Modal|Turn On|internal|event167,evar48=MER-web-securityPreferencesModal-turnOn';
export const CLICK_TRACK_TURN_OFF =
  'Security Preferences Modal|Turn Off|internal|event167,evar48=MER-web-securityPreferencesModal-turnOff';
export const UPGRADE_REQUEST_CLICK_TRACK = 'Upgrade Request Tile|Submit Request Button|internal';
export const MODIFY_REQUEST_CLICK_TRACK = 'Modify Request Tile|Update Request Button|internal';
export const CANCEL_RQUEST_CLICK_TRACK = 'Cancel Request Tile|Cancel Request Button|internal';
export const ROOM_DETAILS_ID = 'showRoomDetailModal';
export const SWEEPSTAKE_ENROLLMENT_CLICK_TRACK = 'Bonvoy Sweepstakes Enrollment|Join|internal|event19';

export const KOREAN_MARKETING_CODES = ['ALL', 'PRTNR', 'HTLDS', 'PRGRM', 'PRGRM_1'];
export const KOREAN_MARKETING_CONSENT_CODES: {
  [key: string]: string[];
} = {
  ALL: ['RSRCH'],
  EML: ['HTLDS', 'PRGRM', 'PRTNR'],
  POST: ['GNRL'],
  SMS: ['MRKT', 'TRNS'],
};

export const KOREAN_CONSENT_FORM_FEATURE_CODE = 'PERSONALIZED_MARKETING_CONSENT';
export const KOREAN_CONSENT_FORM_FEATURE_CODE_GET = 'personalized-marketing-consent';
export const KOREAN_CONSENT_FORM_FEATURE_CODE_VALUE = 'Y';
export const KOREAN_CONSENT_FORM_FEATURE_CODE_DENIED_VALUE = 'N';

export const ALLOW_TARGETED_ADVERTISING_CODE = 'ALLOW_TARGETED_ADVERTISING';
export const ALLOW_TARGETED_ADVERTISING_CODE_GET = 'allow-targeted-advertising';
export const PAID_MEDIA_MARKETING_CONSENT_CODE = 'IBTPS';

export const CORE_REQUIRED_CONSENT = 'CORE_REQUIRED_CONSENT';
export const CORE_REQUIRED_CONSENT_VALUE = 'Y';
export const CORE_TYPES = ['PERSONAL_REQUIRED', 'CROSSBORDER_PERSONAL_REQUIRED'];

export const KOREAN_PERSONAL_CODES = ['TRNS', 'TRNS_1', 'MRKT'];
export const KOREAN_MARKETING_TYPE = 'EML';
export const KOREAN_PERSONAL_TYPE = 'SMS';
export const KOREAN_TYPE_ALL = 'ALL';
export const SNA_Status_REQUESTED = 'requested';
export const SNA_Status_DENIED = 'denied';
export const SNA_Status_GUARANTEED = 'guaranteed';
export const SNA_Status_REMOVED = 'removed';
export const SNA_REQUEST_CREATE_CODE = 'create';
export const SNA_REQUEST_UPDATE_CODE = 'update';
export const SNA_REQUEST_CANCEL_CODE = 'cancel';
export const PROPERTY_ACRS = 'ACRS';

export const CONSENT_FORM_ADDRESS_TYPE = 'HOME';
export const CONSENT_FORM_LOGIN_COUNTS = ['1', '4', '7'];
export const CONSENT_FORM_AGE_DEFAULT = 0;
export const EMEA_CONSENT_FORM_COUNTRY_CODES = ['AE', 'UK', 'DE', 'GB'];
export const KOREA_COUNTRY_CODE = 'KR';
export const CONSENT_FORM_DECRYPT_ENDPOINT = '/mi/phoenix-encryption/v1/aesDecrypt';
export const EMEA_CONSENT_FORM_TYPE = 'EML';
export const EMEA_AEM_CONSENT_CODE_TYPE = 'EMEA';
export const EMEA_CONSENT_FORM_CODES = ['PRGRM'];
export const EMEA_CONSENT_NEW_CODES = ['ALL', 'PRGRM', 'MRKT', 'OPTED_OUT_PERSONALIZATION'];
export const EMEA_CONSENT_TEMP_CODES = ['OPTED_OUT_PERSONALIZATION', 'PRGRM_1', 'PRTNR_1'];
export const EMEA_CONSENT_FORM_HTLDS_CODE = 'HTLDS';
export const EMEA_CONSENT_FORM_PRGRM_CODE = 'PRGRM';
export const EMEA_CONSENT_FORM_PRGRM_NEW_CODE = 'PRGRM_1';
export const EMEA_CONSENT_FORM_PRTNR_NEW_CODE = 'PRTNR_1';
export const EMEA_CONSENT_FORM_MRKT_CODE = 'MRKT';
export const EMEA_CONSENT_COMMON_CODES = ['HTLDS', 'PRGRM'];
export const CONSENT_FORM_KOREA_COOKIE_NAME = 'MarketingConsent';
export const CONSENT_FORM_EMEA_COOKIE_NAME = 'EmeaMarketingConsent';
export const SkeletonLoaderDuration = '5100ms';
export const BACKGROUND_COLOR_PAGE_ARRAY = [
  '/loyalty/myAccount/savedHotels',
  '/loyalty/myAccount/activity',
  '/loyalty/myAccount/missingStayRequest',
  '/loyalty/findReservationList',
  '/loyalty/myAccount/promotionCentral',
  '/loyalty/myAccount/default',
  '/loyalty/myAccount/profile',
  '/loyalty/requestNightlyUpgradeAwards',
  '/loyalty/member-benefits',
  '/loyalty/points-expiration',
];
export const OVERVIEW_PAGE_URL = '/loyalty/myAccount/default';
export const ACTIVITY_COUNT = 3;
export const DEFAULT_VALUE_SET_RECENT_DURATION_FILTER = '24';
export const NO_UPCOMING_TRIPS_POLICY_LOCALES = ['en-US', 'en_US', 'en_CN', 'en-CN'];
export const CURRENT_YEAR = new Date().getFullYear();
export const overviewUpcomingTripsCount = 1;

// MOVALBLE COMPONENTS ENUM ORDERING SHOULD NOT BE CHANGED UNLESS ITS PART OF REQUIREMENT
export enum OverviewMovableComponents {
  UPCOMING_TRIPS = 'upcoming-trips',
  EARNINGS_SUMMARY = 'earnings-summary',
  RECENT_ACTIVITIES = 'recent-activities',
  EARNED_REWARDS = 'earned-rewards',
  PROMOTIONS = 'promotions',
  NONE = 'none',
}

export const REGISTERED_PROMOTIONS_ID = 'registered-promotions-movable';
export const TWO_STEP_VERIFICATION_ID = 'two-step-verification';
export const COMMUNICATION_PREFERENCE = 'communication-consent';
export const ROOM_PREFERENCE_ID = 'room-preferences';
export const AMBASSADOR_ELITE_PREFERENCE_ID = 'ambassador-elite-preferences';
export const EARNING_AND_REWARDS_MODAL_ID = 'earning-and-rewards';
export const EDIT_CARD_MODAL_ID = 'card-details';
export const EDIT_PERSONAL_INFO_ID = 'personal-info';
export const EDIT_CHANGE_PWRD_ID = 'change-password';
export const FORGOT_PWRD_ID = 'forgot-pwrd';
export const FOOD_AND_BEVERAGE = 'food-beverage-preferences';
export const POINTS_TRANSFER_ID = 'points-transfer';
export const INTERESTS_AND_PSN = 'interests-and-passions';
export const TRUSTED_DEVICES = 'trusted-devices';
export const ADD_GIFT_CARD_ID = 'add-gift-card';
export const VERIFIED_SPECIAL_RATES = 'verified-special-rates';
export const GIFT_CARD_MIN_LENGTH = 8; // Minimum digits required
export const GIFT_CARD_MAX_LENGTH = 25; // Maximum digits allowed (configurable via feature flag)
export const GIFT_CARD_PIN_LENGTH = 4;

export const OPTED_OUT_PERSONALIZATION_KEY = 'opted-out-personalization';
export const EMEA_OPTED_OUT_PERSONALIZATION_KEY = 'OPTED_OUT_PERSONALIZATION';
export const DEFAULT_VIEW_BILL_FILE_NAME = 'Activity';
export const FILENAME_REGEX = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

interface LocaleDateFormatObj {
  excludeYear: string;
  onlyDate: string;
  fullDate: string;
  calendarView: string;
  fullMonth: string;
  numericDate: string;
  prefillFullDate: string;
  shortDate: string;
  excludeDate: string;
}

export const ROOM_PREF_PRIORITYTYPE = 'PR';
export const ROOM_PREF_AMENTITIES = 'RA';
export const ROOM_PREF_TYPE = 'RO';
export const ROOM_PREF_ROOM_LOCATION = 'RL';
export const ROOM_PREFERENCE_ROOM_LOCATION = {
  HIGH_FLOOR: 'H1',
  LOW_FLOOR: 'L2',
  NEAR_ELEVATOR: 'N1',
  NO_PREFERENCE: 'NP',
};

export const localeDateFormats: Record<string, LocaleDateFormatObj> = {
  'pl-PL': {
    //Polish
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM. YYYY',
  },
  'tr-TR': {
    //Turkish
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, MMM DD',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'th-TH': {
    //Thai
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd[.] D[.] MMM[.]',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'id-ID': {
    //Indonesian
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'el-GR': {
    //Greek
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, DD MMM.',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'hi-IN': {
    //hindi
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM, YYYY',
    calendarView: 'ddd, DD MMMM',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'nl-NL': {
    //Dutch
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'dd DD MMM',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD-MM-YYYY',
    shortDate: 'DD-MM',
    excludeDate: 'MMM. YYYY',
  },
  'sv-SE': {
    //Swedish
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, D MMM[.]',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'YYYY-MM-DD',
    shortDate: 'MM-DD',
    excludeDate: 'MMM YYYY',
  },
  'it-IT': {
    //Italian
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'fr-FR': {
    //French
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd DD MMM',
    fullMonth: 'Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'he-IL': {
    //Hebrew
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'MMM DD, dd',
    fullMonth: ' Do MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  },
  'zh-TW': {
    //Traditional Chinese
    excludeYear: 'MMM DD[日]',
    onlyDate: 'DD[日]',
    fullDate: 'YYYY[年]M[月]DD[日]',
    calendarView: 'M[月] D[日], ddd',
    fullMonth: 'M[月] D[日]',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'YYYY/MM/DD',
    shortDate: 'MM/DD',
    excludeDate: 'YYYY[年] M[月]',
  },
  'zh-CN': {
    //Simplified Chinese
    excludeYear: 'M[月]D[日]',
    onlyDate: 'D[日]',
    calendarView: 'M[月]D[日], ddd',
    fullDate: 'YYYY[年]M[月]D[日]',
    fullMonth: 'M[月]D[日]',
    numericDate: 'YYYY/M/D',
    prefillFullDate: 'YYYY/M/D',
    shortDate: 'M/D',
    excludeDate: 'YYYY[年] M[月]',
  },
  'vi-VN': {
    //Vietnamese
    excludeYear: 'DD [thg] M',
    onlyDate: 'DD',
    fullDate: 'DD [thg] M, YYYY',
    calendarView: 'ddd, DD Tháng M',
    fullMonth: 'DD [Tháng] M',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: '[Tháng] M YYYY',
  },
  'da-DK': {
    excludeYear: 'DD. MMM',
    onlyDate: 'DD',
    fullDate: 'DD. MMM YYYY',
    calendarView: 'ddd[.] DD[.] MMM[.]',
    fullMonth: 'D[.] MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  }, //Danish
  'nb-NO': {
    excludeYear: 'DD. MMM',
    onlyDate: 'DD',
    fullDate: 'DD. MMM YYYY',
    calendarView: 'ddd[.] DD[.] MMM',
    fullMonth: 'D[.] MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD.MM.YYYY',
    shortDate: 'DD.MM',
    excludeDate: 'MMM YYYY',
  }, //Norwegian
  'fi-FI': {
    excludeYear: 'DD.M',
    onlyDate: 'DD',
    fullDate: 'DD.M.YYYY',
    calendarView: 'dd DD[.] MMM',
    fullMonth: 'DD[.]M',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM[.] YYYY',
  }, //Finnish
  'ar-AE': {
    excludeYear: 'MMM DD',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'DD MMM, ddd',
    fullMonth: 'MMMM DD[,] ddd',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'YYYY MMM',
  }, //Arabic
  'ko-KR': {
    excludeYear: 'M[월] DD[일]',
    onlyDate: 'DD[일]',
    fullDate: 'YYYY[년] M[월] DD[일]',
    calendarView: 'M[월] D[일], ddd',
    fullMonth: 'MM[월] DD[일]',
    numericDate: 'YYYY/MM/DD',
    prefillFullDate: 'YYYY/MM/DD',
    shortDate: 'MM/DD',
    excludeDate: 'YYYY[년] M[월]',
  }, //Korean
  'es-ES': {
    excludeYear: 'DD [de] MMM',
    onlyDate: 'DD',
    fullDate: 'DD [de] MMM, YYYY',
    calendarView: 'ddd, D MMM',
    fullMonth: 'DD [de] MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  }, //Spanish
  'pt-BR': {
    excludeYear: 'DD [de] MMM',
    onlyDate: 'DD',
    fullDate: 'DD [de] MMM [de] YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'DD [de] MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  }, //Portuguese
  'de-DE': {
    excludeYear: 'DD. MMM',
    onlyDate: 'DD.',
    fullDate: 'DD. MMM YYYY',
    calendarView: 'ddd, DD. MMM',
    fullMonth: 'DD[.] MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  }, //German
  'ja-JP': {
    excludeYear: 'M[月]DD[日]',
    onlyDate: 'DD[日]',
    fullDate: 'YYYY[年]M[月]DD[日]',
    calendarView: 'M[月]D[日](ddd)',
    fullMonth: 'MM[月]DD[日]',
    numericDate: 'YYYY/MM/DD',
    prefillFullDate: 'YYYY/MM/DD',
    shortDate: 'MM/DD',
    excludeDate: 'YYYY[年]M[月]',
  }, //Japanese
  'en-GB': {
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'MMMM Do',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY',
  }, // English (United Kingdom)
  'ru-RU': {
    excludeYear: 'DD MMM',
    onlyDate: 'DD',
    fullDate: 'DD MMM YYYY r.',
    calendarView: 'ddd[.], DD MMM',
    fullMonth: 'DD MMMM',
    numericDate: 'DD/MM/YYYY',
    prefillFullDate: 'DD/MM/YYYY',
    shortDate: 'DD/MM',
    excludeDate: 'MMM YYYY r.',
  }, //Russian
  'en-US': {
    excludeYear: 'MMM DD',
    onlyDate: 'DD',
    fullDate: 'MMM DD, YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'MMMM Do',
    numericDate: 'MM/DD/YYYY',
    prefillFullDate: 'MM/DD/YYYY',
    shortDate: 'MM/DD',
    excludeDate: 'MMM YYYY',
  }, //United States
  default: {
    excludeYear: 'MMM DD',
    onlyDate: 'DD',
    fullDate: 'MMM DD, YYYY',
    calendarView: 'ddd, DD MMM',
    fullMonth: 'MMMM Do',
    numericDate: 'MM/DD/YYYY',
    prefillFullDate: 'MM/DD/YYYY',
    shortDate: 'MM/DD',
    excludeDate: 'MMM YYYY r.',
  },
};

export const localesWithDateFirst = [
  'pl-PL',
  'tr-TR',
  'th-TH',
  'id-ID',
  'el-GR',
  'nl-NL',
  'sv-SE',
  'it-IT',
  'fr-FR',
  'he-IL',
  'vi-VN',
  'nb-NO',
  'fi-FI',
  'es-ES',
  'pt-BR',
  'de-DE',
  'ru-RU',
  'en-GB',
  'hi-IN',
];

export const localesWithLowerCaseSplCharacters = ['vi-VN', 'es-ES', 'pt-BR'];

export const PLATINUM_CORE_CODE = 'P';

export const PLATINUM_ACHIEVER_LEVELTYPE = 'PAC';
export const PLATINUM_REFERRRAL_LEVELTYPE = 'PAR';
export const PLATINUM_LIFETIME_ELITE_LEVELTYPE = 'PLR';

export const PLATINUM_PREMIER_PFS_LEVELTYPE = 'PFS';
export const PLATINUM_PREMIER_PFR_LEVELTYPE = 'PFR';

export const PLATINUM_PREMIER_ELITE_LEVELTYPE = 'PPE';
export const PLATINUM_PREMIER_ELITE_AMBASSADOR_LEVELTYPES = 'PPAE';
export const changePwrdURL = '/mi/phoenix-account-auth/v1/changePassword';
export const newPwrdAPI = '/mi/phoenix-account-auth/v1/newPasswordSubmit';
export const cancelStatus = ['pending', 'requested', 'cancelled'];
export const cancelStatusGuaranteed = 'guaranteed';
export const cancelStatusForfeited = 'forfeited';
export const STATUS_CANCELLED = 'cancelled';
export const API_ERROR_KEY = 'uxlFailureErrorMessage';
export const DUPLICATE_PHONE_ERROR_KEY = 'phoneAlreadyAssociatedError';
export const MOBILE_PHONE_UNIQUENESS_ERROR = 'mobilePhoneUniquenessError';
export const PHONE_UNIQUENESS_ERROR_KEY = 'phoneUniquenessError';
export const EXISTING_ACCOUNT_ERROR_MESSAGE = 'existingAccountInlineErrorMessage';
export const MOBILE_PHONE_REQUIRED_ERROR_KEY = 'mobilePhoneRequired';
export const DUPLICATE_EMAIL_ERROR_KEY = 'duplicateEmailError';
export const EMAIL_DUPLICATE_ERROR = 'emailDuplicateError';
export const EMAIL_UNIQUENESS_ERROR = 'emailUniquenessError';
export const INVALID_EMAIL_ADDRESS = 'invalidEmailAddress';
export const INVALID_EMAIL_INLINE_ERROR = 'emailInvalidInlineError';
export const ACTIVATE_SUCCESS_SIGNIN_FAILED_ERROR_KEY = 'activationSuccessSignInFailedError';

export const FCP_HURDLE_WITHOUT_ENDPOINT = '/mi/phoenix-account-auth/v1/changePassword';
export const VIEW_GIFT_CARD_INFO_ENDPOINT = '/mi/phoenix-account-auth/v1/viewGiftCardInfo';
export const CANCEL_REDIRECTION_URL = '/sign-in.mi';
export const PROFILE_REDIRECTION_URL = '/loyalty/myAccount/profile.mi';
export const RFP_URL = '/meetings-events/rfp/event-profile.mi?isRewardsFlow=true';

export const UPDATE_CUSTOMER_PROFILE = '/mi/phoenix-account-auth/v1/updateCustomerProfile';
export const TRUSTED_DEVICES_ENDPOINT = '/mi/phoenix-account-auth/v1/unregisterDevices';

export const CHINESE_MOBILE_CODE = '+86';
export const CHINESE_MOBILE_LENGTH = 11;
export const ALPHABETS_REGEX = /^[a-zA-Z]+$/;
export const NUMBERS_REGEX = /^[0-9]+$/;
export const MOB_NUM_MIN_LENGTH = 7;

// SWEEPSTAKES CONSTANTS

export const CONSENT_METHOD_SMS = 'SMS';
export const CONSENT_METHOD_EMAIL = 'EML';
export const SWEEPSTAKES_ENTER_NOW_URL = '/mi/phoenix-account-navigation/v1/sweepStakeflowEntry';
export const ARIES_SEND_OTP_CHALLENGE_URL = '/loyalty/myAccount/sweepstakes/send-otp-challenge.mi';
export const SWEEPSTAKES_FINAL_URL = '/mi/phoenix-account-navigation/v1/sweepStakeEventEnrollment';
export const SWEEPSTAKES_PREPROCESSOR_PATH_PARAM = '/sweepstakesEvent';
export const SWEEPSTAKES_ENTRY_PAGE_URL = '/loyalty/sweepstakes';

export const SWEEPSTAKES_CONSENT_CODES = {
  [CONSENT_METHOD_SMS]: ['MRKT'],
  [CONSENT_METHOD_EMAIL]: ['PRGRM'],
};

export enum SweepstakesErrorTypes {
  INELIGIBLE_ERROR = 'ineligibleError',
  DUPLICATE_ERROR = 'duplicateError',
  RECENTLY_ENROLLED = 'recentlyEnrolled',
  GENERIC_ERROR = 'genericError',
}

export const CONSENT_TYPE_ONE_COUNTRY_SET = [
  'AU',
  'BD',
  'BT',
  'KH',
  'FJ',
  'PF',
  'GU',
  'HK',
  'IN',
  'ID',
  'JP',
  'MO',
  'MY',
  'MV',
  'NP',
  'NC',
  'NZ',
  'PH',
  'SG',
  'LK',
  'TW',
  'TH',
  'VN',
  'WS',
];
export const UNIQUE_CONSENT_TYPE_COUNTRY_SET = ['CN', 'VN', 'KR', 'US', 'JP'];
// zh-TW and zh-CN locale has unique consent for compliance, which is unavailable in other locales
export const UNIQUE_CONSENT_GREATER_CHINA = ['HK', 'MO', 'TW'];

export const COUNTRY_SET_CN_VN_KR = ['CN', 'VN', 'KR'];
export const COUNTRY_SET_CN_VN_JP = ['CN', 'VN', 'JP'];
export const COUNTRY_SET_VN_KR = ['VN', 'KR'];
export const COUNTRY_SET_CN_VN_KR_JP = ['CN', 'VN', 'KR', 'JP'];

export const IS_DEFAULT_UNCHECKED = [
  'AD',
  'AU',
  'BH',
  'BG',
  'CA',
  'HR',
  'EG',
  'EE',
  'IN',
  'IT',
  'JP',
  'CS',
  'XK',
  'LV',
  'LT',
  'MT',
  'NG',
  'NO',
  'QA',
  'SA',
  'RS',
  'SK',
  'SI',
  'AE',
  'CH',
  'VN',
  'CL',
  'CR',
  'PE',
  'AT',
  'BE',
  'CY',
  'CZ',
  'DK',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'LU',
  'NL',
  'PL',
  'PT',
  'RO',
  'ZA',
  'ES',
  'SE',
  'TR',
  'GB',
  'CN',
  'HK',
  'KO',
  'SG',
  'KZ',
  'RU',
  'CO',
];
export const COUNTRY_CODE_ADD_CARD_ZIPINPUT = ['US', 'CA'];
export enum LOOKUPTYPE_CODES {
  CHINA_STATE_OPTIONS = 'CHINA_STATE_OPTIONS',
}
export const mi_consent = 'mi_consent';
export const tp_consent = 'tp_consent';

export const JOIN_NOW_CANCEL_URL = '/default.mi';
export const SYSTEM_MAINTENANCE_URL = '/profile/systemMaintenance.mi';
export const SERVICE_UNAVIALABLE_PAGE = '/reservation/800Page.mi';
export const OVERVIEW_REGISTERED_PROMO_SORT_ORDER: { [key: string]: number } = {
  RSP: 1,
  RE: 2,
  RNP: 3,
};

export const COMMA_DELIMITER = ',';
export const DOT_SYMBOL = '•';

export const PROFILE_CONSTANTS = {
  REMEMBER_ME_FLAG: 'RememberMeFlag',
  COUNTRY_TYPE: 'country',
  USER_TYPE: 'user',
  ALL: 'ALL',
  VIEW_AWARDS: 'view-awards',
  DYNAMIC_LINE_ITEM_ID: {
    MEMBER_NUMBER: 'member-number',
    LINKED_ACCOUNTS: 'linked-accounts',
    CREDITCARD: 'card-details',
    REMEMBER_ME: 'remember-me',
    ADD_CARD: 'add-card',
    TRUSTED_DEVICES: 'trusted-devices',
    GIFT_CARDS: 'gift-card-details',
    ADD_GIFT_CARD: 'add-gift-card',
    VERIFIED_SPECIAL_RATES: 'verified-special-rates',
    VIEW_GIFT_CARDS: 'gift-card-details',
  },
  CONDITIONAL_USER_COUNTRY_LINE_IDS: ['two-step-verification', 'trusted-devices'], // add if any other line item has to be hidden/shown based profile country
  PHONE_TYPE: {
    BUSINESS: 'BT',
    HOME: 'HT',
    DEFAULT: 'MT',
  },
  GENDER: {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER',
  },
  PROFILE_GENDER: {
    MALE: 'M',
    FEMALE: 'F',
  },
  GIFT_CARD_DESCRIPTION: {
    STORED_VALUE: 'Stored Value',
  },
  GIFT_CARD_STATUS: {
    CANCELED: 'CANCELED',
    CANCELLED_FOR_REMITTANCE: 'CANCELLED_FOR_REMITTANCE',
  },
};
export const FCP_REDIRECTION_URL = '/loyalty/myAccount/changePasswordChallenge.mi';
export const MEMBER_STATUS_LIST_LEVEL_HIERARCHY: {
  [key: string]: Array<string>;
} = {
  /**
   * lifetime to core level
   */
  PL7: ['PPR', 'PPC', 'PPE'],
  GLR: ['GAR', 'GAC', 'G'],
  SLR: ['SAR', 'SAC', 'S'],
  PLR: ['PAR', 'PAC', 'P'],
};

export const COMMUNICATION_SUBSCRIBED = [
  {
    method: 'EML',
    type: 'PRGRM',
  },
  {
    method: 'EML',
    type: 'PRTNR',
  },
  {
    method: 'SMS',
    type: 'MRKT',
  },
  {
    method: 'POST',
    type: 'GNRL',
  },
  {
    method: 'SMS',
    type: 'TRNS',
  },
  {
    method: 'ALL',
    type: 'RSRCH',
  },
];
export const SUCCESS_CODE = 'Success';
export const FAILURE_CODE = 'Failure';
export const PROCESS_CREDIT_CARD_ENDPOINT = '/mi/phoenix-payment/v1/processCreditCard';
// error value returned from Backend for Missing Stay Request
export const MSR_ERROR_CONSTANTS = {
  PHONE_NUMBER_WARNING: 'phoneNumberWarning',
  EMAIL_WARNING: 'emailAddressWarning',
};

export const ENROLL_ENDPOINT = '/mi/phoenix-account-auth/v1/enroll';
export const ENROLL_ENDPOINT_DTT = '/mi/phoenix-account-auth/v2/enroll';
export const ENCRYPT_KEY_ENDPOINT = '/mi/phoenix-account-auth/v1/encryptionKey/credential';
export const CREATE_ACCOUNT_CLICK_VAL = 'Create Account|Activate Account Link|internal';
export const GEN_OTP_SESSION_EXPIRED = 'userSessionExpired';

export const BANNER_MSGS_ERROR_TYPE = 'error';
export const BANNER_MSGS_ERROR_VALUE = 'error-sev1';

export enum BANNER_MSGS_KEYS {
  ACCOUNT_UPDATED_MSG = 'accountUpdatedMsg',
  TWO_STEP_VERIFICATION_MSG = 'twoStepVerficationMsg',
  TWO_STEP_VERIFICATION_ADD_PHONE_SUCCESS_MSG = 'twoStepVerficationAddPhoneMsg',
  PWRD_UPDATED_MSG = 'passwordUpdatedMsg',
  NEW_MEMBER_NUMBER_MSG = 'newMemberNumberMsg',
  RESERVATION_NOT_LINKED_ERROR_MSG = 'reservationNotLinkedErrorMsg',
  NIGHT_UPGRADE_ERROR = 'nightUpgradeError',
  UXL_ERROR_MSG = 'showUxlErrorMsg',
  ICC_SUCCESS_MSG = 'iccSuccessMessage',
  ICC_PENDING_MSG = 'iccPendingMessage',
  TRUSTED_DEVICES_NO_DEVICES_MSG = 'trustedDevicesNoDevicesMsg',
  TRUSTED_DEVICES_REGISTERED_SUCCESS_MSG = 'trustedDevicesMsg',
  TRUSTED_DEVICES_ERROR_MSG = 'trustedDevicesErrorMsg',
  GIFT_CARD_SUCCESS_MSG = 'giftCardSuccessMessage',
  VERIFIED_SPECIAL_RATES_ERROR_MSG = 'verifiedSpecialRatesErrorMsg',
  GIFT_CARD_REPORT_LOST_MSG = 'giftCardReportMessage',
  GIFT_CARD_REMOVE_MSG = 'giftCardRemoveMessage',
}

export enum NOTIFICATION_BANNER_KEYS {
  MISSING_MOBILE_NUMBER = 'missingMobileNumber',
  MOBILE_OTP_VERIFICATION = 'mobileOtpVerificationNudge',
  MEMBER_ALL = 'memberAll',
  COBRAND_LANE_MESSAGE_BANNER = 'cobrandLane',
  STAY_AND_PAY = 'stayPay',
}

export enum EARNING_AND_REWARDS_OPTIONS {
  POINTS = 'HP',
  MILES = 'MI',
}
export const NIGHT_DETAIL_LABEL_SWAP_FOR_LOCALE = ['it_IT', 'de_DE', 'pt_BR'];

export const CREDIT_CARD_CODES: {
  [key: string]: string;
} = {
  V: 'VS',
  M: 'MC',
  A: 'AX',
  R: 'DS',
  D: 'DC',
  J: 'JC',
  UA: 'UA',
  UP: 'UP',
};

export const ADD_MOBILE_NUMBER_PATH = '/loyalty/myAccount/addMobileNumber.mi';
export const PHONE_NUMBER_REGEX = /^[0-9]+$/;
export const LOGIN_URL = '/mi/phoenix-account-auth/v1/loginWithCredentials';
export const LOGIN_LINK_RESERVATION_URL = '/mi/phoenix-account-auth/v1/loginWithCredentialsAndLink';
export const LOGIN_LINK_RESERVATION_DTT_URL = '/mi/phoenix-account-auth/v2/loginWithCredentialsAndLink';
export const EAA_FCP_WARNING_MESSAGE_KEY = 'eaaFcpWarningMessage';

export enum ENROLLMENT_KOREAN_CONSENT_ENUM {
  KRPRC = 'KRPRC',
  KRCBC = 'KRCBC',
  MRKT = 'MRKT',
  TRNS = 'TRNS',
  TRNS_1 = 'TRNS_1',
  HTLDS = 'HTLDS',
  PRGRM = 'PRGRM',
  PRGRM_1 = 'PRGRM_1',
  PRTNR = 'PRTNR',
}

export enum SMS_TYPE_CODES {
  TRNS = 'TRNS',
  MRKT = 'MRKT',
}

export enum ENROLLMENT_CHINA_CONSENT_ENUM {
  SOCN = 'SOCN',
  SPCN = 'SPCN',
  CNCBC = 'CNCBC',
  CNPRC = 'CNPRC',
}

export enum ENROLLMENT_VIETNAM_CONSENT_ENUM {
  SOVN = 'SOVN',
  SPVN = 'SPVN',
  VNCBC = 'VNCBC',
  VNPRC = 'VNPRC',
}

export enum ENROLLMENT_US_CONSENT_ENUM {
  SO = 'SO',
  SP = 'SP',
}

export enum ENROLLMENT_CONSENT_TYPES {
  CORE_REQUIRED_CONSENT = 'CORE_REQUIRED_CONSENT',
  SUBSCRIPTION_OFFER = 'subscriptionsOffers',
  SUBSCRIPTION_3RD_OFFER = 'subscriptions3rdParty',
  PERSONALIZED_MARKETING_CONSENT = 'PERSONALIZED_MARKETING_CONSENT',
}
export const USER_STATE_AUTHENTICATED = 'Authenticated';

export enum ONE_CLICK_JOIN_ERROR {
  PROHIBITED_ERROR = 'prohibitedCountryErrMsg',
  EMAIL_DUPLICATE_ERROR = 'emailDuplicateError',
  API_ERROR = 'uxlFailureErrorMessage',
}
export const CREATE_ACCOUNT_API_ERROR = {
  [EMAIL_DUPLICATE_ERROR]: {
    partnerError: 'existingAccountInlineErrorMessage',
    default: 'emailUniquenessError',
  },
  [DUPLICATE_PHONE_ERROR_KEY]: {
    partnerError: 'existingPhoneErrorMsg',
    default: 'phoneUniquenessError',
  },
  [MOBILE_PHONE_REQUIRED_ERROR_KEY]: {
    partnerError: '',
    default: 'inlineErrorMsgMobNumMandatory',
  },
};

export const EditPersonalInfoModalErrorList = [
  'uxlFailureErrorMessage',
  'customerProfileUpdateFailure',
  'invalidUserInfo',
  'phoneAlreadyAssociatedError',
  'duplicateEmailError',
  'emailUniquenessError',
  'mobilePhoneUniquenessError',
];

export const SYSTEM_MAINTENANCE_ERROR_URL = '/profile/systemMaintenance.mi?type={0}';
export const COMPLETE_PROFILE_URL = '/loyalty/myAccount/editPersonalInformation.mi';

export enum CUSTOM_PROFILE_TRACK_Val {
  BOOK_HOTEL_TRACK_VAL = '3 Pack Welcome Tile|Book A Hotel|internal|event167, event168, evar48=MER-web-enrollWelcomeTile-BookHotel',
  VIEW_BENEFITS_TRACK_VAL = '3 Pack Welcome Tile|View Benefits|internal|event167, event168, evar48=MER-web-enrollWelcomeTile-ViewBenefits',
  COMPLETE_PROFILE_TRACK_VAL = '3 Pack Welcome Tile|Complete Profile|internal|event167, event168, evar48=MER-web-enrollWelcomeTile-CompleteProfile',
}

export const LAST_ATTEMPT_WARNING_KEY = 'incorrect.password.last.attempt.remaining';

export const LOCKEDOUT_ERROR_KEY = 'account.lockedout.dueto.password.failure.attempts';
export const ALREADY_COMBINED_ERROR_KEY = 'transferred.marriott.rewards.account.status';
export const AUDIT_WARNING_MESSAGE = 'audit.marriott.rewards.account.status';
export const PWRD_ERROR_MSG = 'password.username.invalid';
export const USERNAME_INVALID_ERROR = 'username.type.invalid';
export const SIGN_IN_PAGE_WARN_MESSAGE = 'signInPageWarnMessage';
export const INVALID_EMAIL_OR_MEMBERERROR = 'invalidEmailOrMemberError';

export const CHECKED_IN_MODAL_ID = 'checked-in';
export const REDEMPTION_DTT_MODAL = 'dtt-points-rate';
export const CHINESE_SOURCE_LANG = 'CHINESE';
export const ENGLISH_SOURCE_LANG = 'ENGLISH';
export enum nightlyUpgradeAwardType {
  suiteNight = 'SUITE_NIGHT_AWARD',
}
export const NUA_UPGRADE_REQUEST = '/mi/phoenix-account-navigation/v1/SNAUpgrade';
export const NUA_UPGRADE_REQUEST_V2 = '/mi/phoenix-account-navigation/v2/SNAUpgrade';
export const CHANGE_CONFIRMATION_ENDPOINT = '/reservation/upcomingReservation.mi';

export const CLICK_TRACK_DYNAMIC_VALUE_PROFILE_EDIT_BTN: Record<string, string> = {
  'ambassador-elite-preferences': 'Profile Preferences|Ambassador Elite Preferences|internal',
  'interests-passions': ' Profile Preferences|Edit Interests & Passions|internal',
  'food-beverage-preferences': 'Profile Preferences|Edit Food & Beverage Preferences|internal',
  'folio-delivery': 'Payment Preferences|Edit Folio Delivery Method|internal',
  'add-gift-card': 'Gift Cards|Add|internal',
  'gift-card-details': 'Gift Cards|View|internal',
};

export const FOOD_BEV_CLICK_TRACK = 'Food & Beverages|Save Food & Beverages|internal';
export const INTERESTS_PASSIONS_CLICK_TRACK = 'Interests and Hobbies|Save Interests & Hobbies|internal';
export const PERSONAL_INFO_CLICK_TRACK = 'Personal Info Modal|Save Your Profile|internal|event200';
export const ROOM_PREFERENCES_CLICK_TRACK = 'Room Options and Stay Preferences|Save|internal';
export const COMMUNICATION_CLICK_TRACK = 'Communication Preferences|Save|internal';
export const EARNING_REWARDS_CLICK_TRACK = 'Earning Preferences|Submit|internal';
export const AMBASSADOR_ELITE_CLICK_TRACK = 'Ambassador Elite Preference|Save|internal';
export const FOLIO_CLICK_TRACK = 'Folio and Delivery Method|Save Folio and Delivery Method|internal';
export const ADD_CARD_CLICK_TRACK = 'Credit-Card-Modal|Save|internal|eVar199=New Card';
export const EDIT_CARD_CLICK_TRACK = 'Credit-Card-Modal|Save|internal|eVar199=Saved Card';
export const LINK_ACCOUNT_CLICK_TRACK = 'Convert Points|Unlink|external';
export const CHANGE_PASSWORD_TOKEN_EXPIRED_ERROR_KEY = 'inActiveUserErrorMsg';

export enum AMBASSADOR_SERVICE {
  REWARDS_MAIN_DIRECT_AMBASSADOR = 'rewardsMainDirect_ambassador',
  REWARDS_MAIN_TOLL_FREE_AMBASSADOR = 'rewardsMainTollFree_ambassador',
}

export enum ENROLLMENT_CONSTANTS {
  LACA = 'LACA_EF',
  MRMB = 'MRMB',
  USMI = 'USMI',
  SOURCE_CODE_KEY_SUFFIX = '_EF',
  ENROLLMENT_ATTEMPT = 'EnrollmentAttempt',
}

export enum CreditCardType {
  V = 'visa',
  A = 'american-express',
  R = 'discover',
  M = 'mastercard',
  D = 'diners-club',
  J = 'jcb',
  UP = 'unionpay',
}

export enum ONE_CLICK_JOIN_MODAL_TYPE {
  CHECKED_IN = 'checkedIn',
  EARN_WHILE_YOU_SLEEP = 'earnWhileYouSleep',
  UPCOMING = 'joinAndSaveReservation',
  SAVE_RESERVATION = 'saveReservation',
  CHECKED_IN_V2 = 'checked-in-v2',
}

export const POINTS_TRANSFER_TYPE = {
  CONVERT_POINTS: 'convert-points',
  FREQUENT_FLYER: 'frequent-flyer',
  MEMBER_TO_MEMBER: 'member-to-member',
};
export const PHOENIX_SEND_OTP_CHALLENGE_URL = '/loyalty/myAccount/send-otp-challenge.mi';

export const EDIT_CHANGE_PWRD_QUERY_PARAM = 'editChangePassword';

export const VIEW_GIFT_CARD_INFO_QUERY_PARAM = 'viewGiftCard';

export const UNSUBSCRIBE_ACTION = 'UNSUBSCRIBE';

export const PREPROCESSOR_PREFIXES_ALL_PAGES = {
  VERSION: 'v1',
  PREPROCESS: 'preprocess',
};

export const DTT_PREPROCESSOR_VERSION = 'v2';

export enum GRAPHQL_PAYLOAD_CONST {
  source = 'WEB',
}

export const NON_SUPPORTED_PHONE_NUMBER = 'non-supported';
export const MARRIOTT_URL = 'https://www.marriott.com';
export const MARRIOTT_URL_CHINA = 'https://www.marriott.com.cn';
export const SHOW_BROWSER_REGISTRATION = 'show_browser_registration';
export const MISSING_STAY_CONFIRMATION_PAGE_PATH = '/loyalty/myAccount/missingStayRequestconfirmation';
export const TRUSTED_DEVICES_NO_DEVICE_CODE = 'no.devices.found';
export const LCA_CONSTANTS = {
  LCA: 'LCA',
  DARK_MODE_EXP: 'DARKMODE',
};
export const DTT_QUERY_PARAM = '_-dtt';

export enum STATUS_IN_BOOLEAN {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
export const all = 'all';
export enum prefHobbies {
  golf = 'GOLF',
  golfLov = 'GOLF_LOV',
  golfDesc = 'GOLF_DESC',
  fitness = 'FITNESS',
  fitnessLov = 'FITNESS_LOV',
  fitnessDesc = 'FITNESS_DESC',
  spaLov = 'SPA_LOV',
  spaDesc = 'SPA_DESC',
  hobbies = 'INTERESTS_AND_HOBBIES',
  hobbiesLov = 'INTERESTS_AND_HOBBIES_LOV',
  hobbiesDesc = 'INTERESTS_AND_HOBBIES_DESC',
}
export enum loyaltyCompassActivityID {
  travel = 'travel-interests',
  phoneNumber = 'phone-number',
}

export enum ImageFetchPriorityKey {
  HIGH = 'high',
  LOW = 'low',
}

export const MODEL_NAME = {
  ONE_CLICK_JOIN_FORM: 'OneClickJoinForm',
  EARNINGS_AND_REWARDS: 'EarningAndRewards',
  SIGN_IN_DRAWER: 'SignInDrawer',
  SIGN_IN_MODEL: 'SignInModel',
};

export const NEW_PASSWORD_FORM = 'newPwrdForm';
export const FORGOT_PASSWORD_FORM = 'forgotPwrd';
export const LOOKUP_MEMBER_NUMBER_FORM = 'lookUpMemberNumber';
export const EXPLORE_RATE_SIGN_IN_FLYOUT = 'explore-rate-sign-in-flyout';
export const SEND_OTP_CHALLENGE_FORM = 'send-otp-challenge';
export const ACCOUNT_CONTAINER_CENTRALIZED = 'account-container-centralized';
export const WEB_PROMPT_CONSENT_FLYOUT = 'web-prompt-consent-flyout';
export const WEB_PROMPT_MOBILE_FLYOUT = 'web-prompt-mobile-flyout';

export const FORGOT_PASSWORD_KEY = 'forgotPwrd';
export const ACTIVATE_ACCOUNT_KEY = 'activateAccount';

export const ACTIVATE_OR_FORGOT_FORM_ID = 'activateOrForgotForm';
export const SIGN_IN_PAGE_ID = 'account-SignIn';

export const LOOKUP_MEMBER_NUMBER_PATH = '/lookUpMemberNumber';
export const FORGOT_PASSWORD_PATH = '/forgotPassword';
export const ACTIVATE_ACCOUNT_PATH = '/loyalty/createAccount/activateAccountChallenge';
export const FCP_PATH = '/loyalty/myAccount/changePasswordChallenge';

export const flyoutModalKeys = {
  ACTIVATE_OR_FORGOT_FORM: 'activateorforgotform',
  SIGN_IN: 'signin',
  NEW_PASSWORD_FORM: 'changepassword',
  SET_PASSWORD: 'setpassword',
  LOOKUP_MEMBER_NUMBER: 'lookupmembernumber',
  CENTRALIZED_FLYOUT: 'isFlyoutCombined',
  CONFIRM_IDENTITY: 'confirmidentity',
  FORCE_CHANGE_PASSWORD: 'forcechangepassword',
  WEB_PROMPT_CONSENT: 'webpromptconsent',
  WEB_PROMPT_MOBILE: 'addmobilephone',
};

export const flyoutLinkMappings: Record<string, { modelKey: string; activeKey: string }> = {
  '/forgotPassword': {
    modelKey: 'forgotPwrd',
    activeKey: flyoutModalKeys.ACTIVATE_OR_FORGOT_FORM,
  },
  '/loyalty/createAccount/activateAccountChallenge': {
    modelKey: 'activateAccount',
    activeKey: flyoutModalKeys.ACTIVATE_OR_FORGOT_FORM,
  },
  '/loyalty/myAccount/send-otp-challenge': {
    modelKey: SEND_OTP_CHALLENGE_FORM,
    activeKey: flyoutModalKeys.CONFIRM_IDENTITY,
  },
  '/lookUpMemberNumber': {
    modelKey: LOOKUP_MEMBER_NUMBER_FORM,
    activeKey: flyoutModalKeys.LOOKUP_MEMBER_NUMBER,
  },
  '/loyalty/myAccount/changePasswordChallenge': {
    modelKey: 'forceChangePwrd',
    activeKey: flyoutModalKeys.FORCE_CHANGE_PASSWORD,
  },
  [WEB_PROMPT_CONSENT_FLYOUT]: {
    modelKey: WEB_PROMPT_CONSENT_FLYOUT,
    activeKey: flyoutModalKeys.WEB_PROMPT_CONSENT,
  },
};

export const PROMPT_FLYOUT_TYPE_MAP = {
  V1: 'web-prompt-consent-flyout',
  V2: 'web-prompt-mobile-flyout',
};

export const BANNER_GRADIENTS = {
  WIDE: {
    md: `linear-gradient(270.21deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 9.92%, rgba(0,0,0,0.54) 43.12%, rgba(0,0,0,0.62) 100%);`,
    xl: `linear-gradient(270.21deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 17.55%, rgba(0,0,0,0.54) 50.59%, rgba(0,0,0,0.62) 100%);`,
  },
  RTL_WIDE: {
    md: `linear-gradient(90.21deg, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 9.92%, rgba(0,0,0,0.54) 43.12%, rgba(0,0,0,0.62) 100%);`,
    xl: `linear-gradient(90.21deg, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 17.55%, rgba(0,0,0,0.54) 50.59%, rgba(0,0,0,0.62) 100%);`,
  },
};

export const nameLimit20 = 20;
export const nameLimit25 = 25;

export const nameErrorMessageCode = {
  firstNameCharLimitErrorMsg: 'firstNameCharLimitErrorMsg',
  lastNameCharLimitErrorMsg: 'lastNameCharLimitErrorMsg',
};

// ============ EARNINGS SUMMARY CONSTANTS ============
export const EARNINGS_SUMMARY_CONSTANTS = {
  // Time windows for component visibility
  MIN_HOURS_POST_STAY: 72, // Show starting 72 hours after earnings posted
  MAX_DAYS_POST_STAY: 30, // Show until 30 days after stay

  // GraphQL query parameters
  QUERY_MONTHS: 4, // Look back 4 months to cover 30-day window with buffer for edge cases
  QUERY_LIMIT: 10, // Fetch recent 10 stays
  QUERY_TYPES: 'STAY', // Filter for hotel stays only

  // Tier progression requirements (nights required to achieve each tier)
  TIER_NIGHT_REQUIREMENTS: {
    R: 0, // Member (Basic)
    S: 10, // Silver Elite
    G: 25, // Gold Elite
    P: 50, // Platinum Elite
    PPC: 75, // Titanium Elite
    PFS: 100, // Ambassador Elite
  } as Record<string, number>,

  // Tier display names (fallback - should come from AEM in production)
  TIER_NAMES: {
    R: 'Member',
    S: 'Silver Elite',
    G: 'Gold Elite',
    P: 'Platinum Elite',
    PPC: 'Titanium Elite',
    PFS: 'Ambassador Elite',
  } as Record<string, string>,

  // Spend thresholds for Titanium/Ambassador qualification
  TITANIUM_SPEND_THRESHOLD_HIGH: 23000, // Primary spend requirement
  TITANIUM_SPEND_THRESHOLD_LOW: 22000, // Alternative spend requirement
  TITANIUM_NIGHTS_FOR_SPEND_WAIVER: 100, // Nights to qualify with lower spend

  // A/B Test Configuration
  VARIATION_SESSION_KEY: 'earnings_summary_ab_variation',
  PLACEMENT_VARIATIONS: {
    SHOP: 'shop' as const,
    BOOK: 'book' as const,
  },

  // Brands with dedicated stores (using UXL brand codes - all confirmed)
  BRANDS_WITH_STORES: [
    'EB', // EDITION - Confirmed from UXL
    'XR', // St. Regis - Confirmed from UXL
    'LC', // The Luxury Collection - Confirmed from UXL
    'FI', // Fairfield - Confirmed from UXL
    'BR', // Renaissance Hotels - Confirmed from UXL
    'MC', // Marriott Hotels - Confirmed from UXL
    'WI', // Westin - Confirmed from UXL
    'MD', // Le Méridien - Confirmed from UXL
    'CY', // Courtyard - Confirmed from UXL
    'FP', // Four Points - Confirmed from UXL
    'JW', // JW Marriott - Confirmed from UXL
    'GE', // Gaylord Hotels - Confirmed from UXL
    'SI', // Sheraton - Confirmed from UXL
    'RZ', // Ritz Carlton - Confirmed from UXL
    'WH', // W Hotels - Confirmed from UXL
  ] as readonly string[],

  // ENC (Elite Night Credit) calculation by brand
  // Brand codes that earn 0.5 ENC per night (1 ENC for every 2 nights)
  // Aligned with mobile app EliteNightCreditsLimitedBrands configuration
  HALF_ENC_BRANDS: [
    'PR', // Protea Hotels
    'XE', // City Express by Marriott
    'XF', // Four Points Flex by Sheraton
    'SE', // Series by Marriott
  ] as readonly string[],

  // Brand codes that earn 0 ENCs
  ZERO_ENC_BRANDS: [
    'RS', // StudioRes - earns 4 pts/$1 but 0 ENCs
  ] as readonly string[],
} as const;

export const DEFAULT_ENROLLMENT_VARIATION = 'A';
export const ENROLLMENT_VARIATION_PHONE_REQUIRED = 'B';
export const ENROLLMENT_VARIATION_PHONE_AND_MFA_REQUIRED = 'C';
export const ENROLLMENT_VARIATION_PHONE_OPTIONAL = 'D';
export const ENROLLMENT_FAIL = 'EnrollmentFailure';
export const PHONE_NUMBER_ERROR = 'PhoneNumberError';
export const VERIFICATION_CODE_ERROR = 'VerificationCodeError';
export const PHONE_ALREADY_ASSOCIATED_ERROR = 'phoneAlreadyAssociatedError';
export const MBOP_FEATURE_FLAG_HEADER = { 'api-version': 'v2' };

// Gift Card API Status Values (as returned by the API)
export const GIFT_CARD_STATUS = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  ON_HOLD: 'ON_HOLD',
  INACTIVE: 'INACTIVE',
  FRAUD: 'FRAUD',
  REISSUED: 'REISSUED',
} as const;

export const MAX_DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31] as const;
